/**
 * Auth Layout
 *
 * Layout for authentication screens (login, signup)
 */
import { Stack } from "expo-router";

export default function AuthLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        // Prevent white flash during navigation by matching app's dark gradient background
        contentStyle: { backgroundColor: '#0a0012' },
        // Instant transition to eliminate white flash visibility window
        animation: 'none',
      }}
    >
      <Stack.Screen name="login" />
      <Stack.Screen name="signup" />
    </Stack>
  );
}
